import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-public-discipline-card',
  components: {},
})
export default class PublicDisciplineCard extends Vue {
  @Prop(Object) readonly item: AnyEntity;

  onActionClicked(action, row) {
    this.$emit('action-clicked', action, row);
  }

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  get imgUrl() {
    if (this.imgFail) {
      if (this.$store.getters['centerSettings/backgroundUrl']) {
        return this.$store.getters['centerSettings/backgroundUrl'];
      } else if (this.$store.getters['centerSettings/logoUrl']) {
        return this.$store.getters['centerSettings/logoUrl'];
      }
      return null;
    }

    return this.item.header_image[this.currentImgField];
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
